"use strict";

exports.__esModule = true;
exports.PlantGridFields = PlantGridFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _AdvancedTimeline = require("../../Timeline/AdvancedTimeline");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for PlantGridElement.
 */
function PlantGridFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _onSelect = function onSelect(dataRange) {
    elementEditor.setProp(path, "dataRange", dataRange);
  };
  var dataRangeOptions = [{
    id: "",
    label: translate("AdvancedDataTableFields.dataRange.reportingPeriod.label", "Reporting Period")
  }, {
    id: "SELECTION",
    label: translate("AdvancedDataTableFields.dataRange.selection.label", "Selection")
  }];
  var selectedDataRange = dataRangeOptions.find(function (dataRange) {
    return dataRange.id === element.props.dataRange;
  }) || dataRangeOptions[0];
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceGrid.itemWidth.label", "Item Width"),
      helperText: translate("DeviceGrid.itemWidth.helperText", "The width of each item in the grid.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 128,
      max: 1024,
      value: element.props.itemWidth || 128,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "itemWidth", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceGrid.itemHeight.label", "Item Height"),
      helperText: translate("DeviceGrid.itemHeight.helperText", "The height of each item in the grid.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 128,
      max: 768,
      value: element.props.itemHeight || 128,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "itemHeight", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceGrid.rowGutter.label", "Row Gutter Size"),
      helperText: translate("DeviceGrid.rowGutter.helperText", "The size of the gap between rows in the grid.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.rowGutter || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "rowGutter", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DeviceGrid.columnGutter.label", "Column Gutter Size"),
      helperText: translate("DeviceGrid.columnGutter.helperText", "The size of the gap between columns in the grid.")
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 0,
      max: 100,
      value: element.props.columnGutter || 0,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "columnGutter", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.ElementActionControlGroup, {
      controlPaths: {
        onClickAction: path
      },
      elementEditor: elementEditor
    }), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("AdvancedTimelineTimeContextSelector.dataRange.label", "Data Range"),
      helperText: translate("AdvancedTimelineTimeContextSelector.dataRange.helperText", "The data range to show in this stripe chart.")
    }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
      items: dataRangeOptions,
      getKey: function getKey(dataRange) {
        return dataRange.id;
      },
      selected: [selectedDataRange],
      onSelect: function onSelect(selectedDataRange) {
        return selectedDataRange.length ? _onSelect(selectedDataRange[0].id) : null;
      },
      renderItemText: function renderItemText(dataRange) {
        return /*#__PURE__*/_react["default"].createElement(_AdvancedTimeline.SelectorOption, {
          value: dataRange.label,
          parentComponent: "AdvancedTimelineTimeContextSelector"
        });
      },
      placeholder: translate("AdvancedTimelineTimeContextSelector.dataRangeSelector.label", "Select Data Range"),
      width: 275
    })));
  });
}